<template>
  <div v-if="selectedPrescription" class="expert-tool-history__stats">
    <div class="expert-tool-history__stats-date">
      {{ $ucfirst($t('alerts.date')) }}: {{ selectedPrescriptionDate }}
    </div>
    <div class="expert-tool-history__stats-content">
      <stats-header
        hide-patient-details
        :blood-pressure="selectedPrescriptionPatientBloodPressure"
        :weight="selectedPrescriptionPatientWeight"
        :cholesterolLDL="selectedPrescriptionPatientCholesterolLDL"
        :glucose="selectedPrescriptionPatientGlucose"
        :knowledge-level-name="selectedPrescriptionPatientKnowledgeLevelName"
        :behaviour-goals="selectedPrescriptionPatientBehaviourGoals"
        :outcome-goals="selectedPrescriptionPatientOutcomeGoals"
        :bmi="selectedPrescriptionPatientBMI"
        :bmi-date="selectedPrescriptionPatientBMIDate"
      ></stats-header>
      <extra-parameters-bar
        hide-patient-details
        :heart-rate="selectedPrescriptionPatientHeartRate"
        :distance-walked="selectedPrescriptionPatientDistanceWalked"
      ></extra-parameters-bar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import StatsHeader from '../../../components/Parts/StatsHeader';
import ExtraParametersBar from '../../../components/Parts/ExtraParametersBar';

/**
 * Component HistoryStats.vue
 *
 * @module HistoryStats
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [deprecated] app/src/APP_DASHBOARD/templates/views/ExpertTool/History/HistoryStats.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'HistoryStats',
  components: {
    StatsHeader,
    ExtraParametersBar,
  },
  computed: {
    ...mapGetters({
      selectedPrescription: 'expertTool/selectedPrescription',
      selectedPrescriptionDate: 'expertTool/selectedPrescriptionDate',
      selectedPrescriptionPatientBloodPressure: 'expertTool/selectedPrescriptionPatientBloodPressure',
      selectedPrescriptionPatientWeight: 'expertTool/selectedPrescriptionPatientWeight',
      selectedPrescriptionPatientCholesterolLDL: 'expertTool/selectedPrescriptionPatientCholesterolLDL',
      selectedPrescriptionPatientGlucose: 'expertTool/selectedPrescriptionPatientGlucose',
      selectedPrescriptionPatientBMI: 'expertTool/selectedPrescriptionPatientBMI',
      selectedPrescriptionPatientBMIDate: 'expertTool/selectedPrescriptionPatientBMIDate',
      selectedPrescriptionPatientKnowledgeLevelName: 'expertTool/selectedPrescriptionPatientKnowledgeLevelName',
      selectedPrescriptionPatientBehaviourGoals: 'expertTool/selectedPrescriptionPatientBehaviourGoals',
      selectedPrescriptionPatientOutcomeGoals: 'expertTool/selectedPrescriptionPatientOutcomeGoals',
      selectedPrescriptionPatientHeartRate: 'expertTool/selectedPrescriptionPatientHeartRate',
      selectedPrescriptionPatientDistanceWalked: 'expertTool/selectedPrescriptionPatientDistanceWalked',
    }),
  },
};
</script>

<style lang="scss">
.expert-tool-history__stats {
  margin-top: 32px;
  margin-bottom: 32px;
  display: flex;
  border-radius: 16px;
  border: 1px solid #d6dbe4;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.87);

  .c-stats-header__row {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    min-height: 54px;
    margin: 0;
  }

  .extra-parameters-bar {
    border-bottom: 0;
    min-height: 52.5px;
    margin: 0;
  }
}

.expert-tool-history__stats-date {
  background-color: #f6f6f8;
  display: flex;
  align-items: center;
  padding: 16px 24px;
  min-width: 220px;
  font-weight: 600;
  border-right: 1px solid #d6dbe4;
}

.expert-tool-history__stats-content {
  flex-grow: 1;
}
</style>
